module.exports = __webpack_public_path__ + "assets/img/VS.2ed05777.png";